import React from 'react';
import adultIcon from '../../../assets/icons/adultIcon.svg';
import babyIcon from '../../../assets/icons/babyIcon.svg';
import femaleIcon from '../../../assets/icons/femaleIcon.svg';
import maleIcon from '../../../assets/icons/maleIcon.svg';
import { ToggleButtonGroupStyled, ToggleButtonStyled } from './styles';

export const ToggleButtons = ({
  name1,
  name2,
  selection,
  handleToggle
}: {
  name1: string;
  name2: string;
  selection: string;
  handleToggle: (val: any) => void;
}) => {
  return (
    <ToggleButtonGroupStyled
      value={selection}
      exclusive
      onChange={handleToggle}
      aria-label="text alignment"
    >
      <ToggleButtonStyled value={name1} aria-label="centered">
        <img
          src={name1 === 'ADULT' ? adultIcon : maleIcon}
          alt={'babyIcon'}
          style={{ paddingRight: '0.625rem' }}
        />
        {name1}
      </ToggleButtonStyled>
      <ToggleButtonStyled value={name2} aria-label="centered">
        <img
          src={name1 === 'ADULT' ? babyIcon : femaleIcon}
          alt={'babyIcon'}
          style={{ paddingRight: '0.625rem' }}
        />
        {name2}
      </ToggleButtonStyled>
    </ToggleButtonGroupStyled>
  );
};
